import { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import {
  Box,
  Tooltip,
  CircularProgress,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Popover,
} from "@mui/material";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import { isMobile } from "../../globalStyles/mobile";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import EditIcon from "../../globalStyles/icons/editIcon";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import { useTheme } from "@mui/styles";
import { toast } from "react-toastify";
import { usersService } from "../../utils/services/usersService";
import UsersDetailsModal from "../user-details-modal";
import { IOSSwitch } from "../switch";
import TableHeader from "../table-header";
import FilterModal from "../filterModal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    border: "none",
    padding: "4px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--row-bg-odd)",
    border: "1px solid var(--border-color)",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--row-bg-even)",
    border: "1px solid var(--border-color)",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));

const UserTableCell = ({
  user,
  handleViewClick,
  handleEditClick,
  handleDeleteClick,
  handleClientAssignClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(user);
        break;
      case "edit":
        handleEditClick(user);
        break;
      case "delete":
        handleDeleteClick(user);
        break;
      case "assign":
        handleClientAssignClick(user);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={handlePopoverOpen}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", padding: "10px" }}>
          <Button
            onClick={() => handleActionClick("edit")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <EditIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Edit
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={() => handleActionClick("view")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>

          <Button
            onClick={() => handleActionClick("delete")}
            style={{ textTransform: "none" }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <DeleteIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                Delete
              </Typography>
            </Box>
          </Button>
          <Button
            onClick={() => handleActionClick("assign")}
            style={{ textTransform: "none" }}
          ></Button>
        </Box>
      </Popover>
    </Box>
  );
};
const UsersList = ({
  data,
  onEditData,
  onDeleteData,
  viewMode,
  selectedUser,
  setSelectedUser,
  currentPage,
  itemsPerPage,
  onChangeFilter,
  filterData,
  client_id,
}) => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openActiveConfirmation, setOpenActiveConfirmation] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [selectedUserData, setSelectedUserData] = useState([]);
  const startIndex = currentPage * itemsPerPage;
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [selectedFilterKey, setSelectedFilterKey] = useState("");
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    options: [],
    loadMoreButton: false,
    searchKey: "",
  });

  const handleDeleteClick = (port) => {
    setSelectedUser(port);
    setOpenConfirmation(true);
  };

  const confirmDelete = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await usersService.delete(selectedUser._id);
      onDeleteData && onDeleteData();
      toast.success("User deleted successfully");
      setOpenConfirmation(false);
    } catch (error) {
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const confirmStatus = async (user, newValue) => {
    try {
      setLoading(true);
      await usersService.edit(
        {
          active: !newValue,
        },
        user,
      );
      onDeleteData && onDeleteData();
      toast.success("User updated successfully");
      setOpenActiveConfirmation(false);
    } catch (error) {
      console.error("Update failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleViewClick = (x) => {
    setSelectedUser(x);
    setOpenViewModal(true);
  };

  const handleClientAssignClick = (x) => {
    setSelectedUser(x);
  };
  useEffect(() => {
    setSelectedUserData(
      data?.map((x) => ({
        ...x,
        action: (
          <UserTableCell
            user={x}
            handleViewClick={handleViewClick}
            handleEditClick={onEditData}
            handleDeleteClick={handleDeleteClick}
            handleClientAssignClick={handleClientAssignClick}
          />
        ),
      })),
    );
  }, [data]);

  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setSelectedFilterKey(filterKey);
    setOpenFilterModal(true);
    setSelectedFilterData(
      filterData?.columns.find((x) => x?.key === filterKey),
    );
  };

  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {selectedUserData?.map((item, index) => (
        <Grid sx={{ paddingBottom: 1 }} item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid var(--border-color)",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {item?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={2}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Name
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Tooltip title={item?.name} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.name}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Code
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={item?.zone_number} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.code}
                    </Typography>
                  </Tooltip>
                </Grid>
                <Grid item xs={5} display={"flex"} alignItems={"center"}>
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    Zip
                  </Typography>
                </Grid>
                <Grid item xs={7}>
                  <Tooltip title={item?.zone_number} arrow>
                    <Typography
                      noWrap
                      sx={{ textAlign: "start" }}
                      fontWeight="500"
                      fontFamily={"poppins"}
                      color={"var(--text-tertiary)"}
                    >
                      : {item?.zip}
                    </Typography>
                  </Tooltip>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const TableSchema = [
    {
      key: "sl_no",
      title: "SL NO",
      render: (item, index) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {startIndex + index + 1}
        </Typography>
      ),
    },
    {
      key: "name",
      title: "NAME",
      filterKey: "name",
      handleOpenFilter: handleOpenFilter,
      displayKey: "name",
    },
    {
      key: "email",
      title: "EMAIL",
      filterKey: "email",
      handleOpenFilter: handleOpenFilter,
      displayKey: "email",
    },
    {
      key: "phone_no",
      title: "Phone",
      displayKey: "phone_no",
    },
    ...(client_id
      ? []
      : [
          {
            key: "clients",
            title: "Clients",
            filterKey: "clients",
            handleOpenFilter: handleOpenFilter,
            render: (item) => (
              <Typography
                fontSize="12px"
                color="var(--text-secondary)"
                fontWeight={400}
                fontFamily={"Poppins"}
              >
                {item?.clients.map((client) => client.business_name).join(", ")}
              </Typography>
            ),
          },
        ]),
    {
      key: "roles",
      title: "Roles",
      filterKey: "roles",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <Typography
          fontSize="12px"
          color="var(--text-secondary)"
          fontWeight={400}
          fontFamily={"Poppins"}
        >
          {item?.roles.map((role) => role.name).join(", ")}
        </Typography>
      ),
    },
    {
      key: "active",
      title: "Active",
      width: "15%",
      filterKey: "active",
      handleOpenFilter: handleOpenFilter,
      render: (item) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
          }}
          onClick={(e) => {
            setSelectedUser(item);
            setOpenActiveConfirmation(true);
            e.stopPropagation();
          }}
        >
          <IOSSwitch checked={Boolean(item?.active)} />
        </div>
      ),
    },
    { key: "action", title: "", width: "3%", displayKey: "action" },
  ];

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
        paddingBottom: 20,
        marginTop: 5,
      }}
    >
      {isMobile() ? (
        renderGridView()
      ) : (
        <TableContainer
          //  className="custom-container"
          sx={{
            // maxHeight: "70vh",
            overflowY: "auto",
            paddingInline: 0.4,
            maxHeight: "100%",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            sx={{
              border: "1px solid var(--border-color)",
            }}
          >
            <TableHead>
              <StyledTableRow>
                {TableSchema.map((column) => (
                  <TableHeader
                    key={column.key}
                    column={column}
                    filterData={filterData}
                    filterKey={column.filterKey}
                    handleOpenFilter={column.handleOpenFilter}
                    title={column.title}
                  />
                ))}
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {selectedUserData?.map((x, index) => (
                <StyledTableRow>
                  {TableSchema.map((column, colIndex) => (
                    <StyledTableCell
                      key={column.key || colIndex}
                      sx={{ width: column.width }}
                    >
                      {column.displayKey ? (
                        <Typography
                          fontSize="12px"
                          color="var(--text-secondary)"
                          fontWeight={400}
                          fontFamily={"Poppins"}
                        >
                          {x[column.displayKey]}
                        </Typography>
                      ) : column.render ? (
                        column.render(x, index)
                      ) : (
                        "--"
                      )}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile() ? "60vh" : `calc(100vh - 250px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" ? renderGridView() : renderListView()}
        </div>
      )}

      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedUser?.name} ?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={(e) => {
          confirmDelete(e);
        }}
      />
      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to ${
          selectedUser?.active ? "deactive" : "active"
        } ${selectedUser?.name}  ?`}
        open={openActiveConfirmation}
        handleClose={() => setOpenActiveConfirmation(false)}
        handleDelete={(e) => {
          confirmStatus(selectedUser._id, selectedUser?.active);
        }}
        deleteButtonTitle={"Yes"}
      />
      <UsersDetailsModal
        users={selectedUser}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedfilterData?.options}
          selectedValues={selectedfilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedfilterData?.sort}
          filterKey={selectedFilterKey}
          hasMore={selectedfilterData?.loadMoreButton}
          displayKey={selectedfilterData?.displayKey}
          id={selectedfilterData?.id}
          fetchApi={selectedfilterData?.fetchApi}
          searchKey={selectedfilterData?.searchKey}
        />
      </Popover>
    </div>
  );
};

export default UsersList;
